module.exports = __webpack_public_path__ + "img/ad3.b1bb0a27.png";